/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestDev from '@/utils/requestDev'
import { APICore, APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')

export function detail(id) {
    return requestRaw({
        url: APICore() + '/brand/product/detail?id=' + id,
        method: 'GET',
    })
}
export function create(data) {
    return requestRaw({
        url: APICore() + '/brand/product/create',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function update(data) {
    return requestRaw({
        url: APICore() + '/brand/product/update?id=' + data.id,
        method: 'POST',
        data: data // untuk array data post
    })
}
export function list(data) {
    return requestDev({
        url: APIReportPHP() + '/brand/product/list-data',
        method: 'POST',
        data: qs.stringify(data) // untuk array data post
    })
}
export function listAgent(data) {
    return requestDev({
        url: APIReportPHP() + '/omni/brand/product/list-data',
        method: 'POST',
        data: qs.stringify(data) // untuk array data post
    })
}
export function deleteData(data) {
    return requestDev({
        url: APIReportPHP() + '/brand/product/delete',
        method: 'POST',
        data: qs.stringify(data) // untuk array data post
    })
}


// WEBPACK FOOTER //
// ./src/api/brandProduct.js